import { render } from "./Assurance.vue?vue&type=template&id=2126a630&ts=true"
import script from "./Assurance.vue?vue&type=script&lang=ts"
export * from "./Assurance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__